// @flow strict

import React, { type Node } from 'react';

import FormErrorNotification from 'client/components/form/formErrorNotification';
import ScrollTo from 'client/components/scrollTo';

type Args = {
  shouldShow: boolean,
  scrollTo: number,
  translateKey: string,
  translateUsing: {
    [key: string]: *,
  },
};

const ErrorNotificationScroll = ({ shouldShow, scrollTo, ...notificationProps }: Args): Node =>
  (shouldShow ? (
    <React.Fragment>
      <FormErrorNotification {...notificationProps} />
      <ScrollTo to={scrollTo} />
    </React.Fragment>
  ) : null);

ErrorNotificationScroll.defaultProps = {
  ...FormErrorNotification.defaultProps,
  scrollTo: 0,
};

export default ErrorNotificationScroll;
